export const getSocketUrl = () => {
  const configuredUrl = import.meta.env.VITE_SOCKET_URL;
  if (configuredUrl) {
    return configuredUrl;
  }

  if (import.meta.env.DEV) {
    return window.location.origin.replace(/:\d+$/, ':3001');
  }

  return window.location.origin;
};
